module.exports = {"g":{"search":"Search","error-occurred":"An error has occurred"},"home":{"search-placeholder":"How to create uncensored content on Hive","n-documents-indexed":"<span class=\"count\">{n}</span> documents indexed","search-tips":"Search Tips"},"search":{"result-info":"<strong>{hits} results</strong> in {took} sec.","sort-popularity":"Popular","sort-relevance":"Relevance","sort-newest":"Recent","no-result":"Nothing Found"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en-US.json
// module id = 193
// module chunks = 0